import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class RequesSetupService {
  constructor(
    private http: HttpClient,
    private zone: NgZone
  ) {}

  urlApiManagement = environment.urlApiManagement;

  getSetup(path: string) {
    const url = `${this.urlApiManagement}` + path;
    return this.http.get(url, {}).pipe(catchError(this.handleError('getSetup()')));
  }

  actionSetup(path: string, body: any) {
    const url = `${this.urlApiManagement}` + path;
    return this.http.post(url, body);
  }

  getModalRequest(path: string, get: any, params: any) {
    if (get) {
      const url = `${this.urlApiManagement}` + path;
      return this.http.get(url, {}).pipe(catchError(this.handleError('getModalMovements()')));
    } else {
      const url = `${this.urlApiManagement}` + path;
      return this.http.post(url, params).pipe(catchError(this.handleError('getModalMovements()')));
    }
  }

  saveCheckUser(path: string, params: any) {
    const url = `${this.urlApiManagement}` + path;
    return this.http.post(url, params).pipe(catchError(this.handleError('getModalMovements()')));
  }

  handleError(error: any) {
    if (!(error instanceof HttpErrorResponse)) {
      return (error = error.rejection);
    }

    this.zone.run(() => console.log('Message: ', error?.message, 'Error: ', error?.status));

    return console.error('Error from global error handler', error);
  }
}
